import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
export default {
  title: 'Interactable Graphic',
  label: 'URL',
  helpText: 'URL of the interactable graphic',
  attributeName: 'interactableGraphic',
  getURL: '',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  itemType:'interactableGraphic',
  
  type:FormInputTypes.TEXT_INPUT.TEXT,
  sessionParams: [],
};
